'use client';
import React from 'react';

import type { Media as MediaType } from '../../../payload/payload-types';
import { KontactProps } from '@/app/_blocks/KontactGraphQL/types';
import { Media } from '../Media';
import { DebugJsonBlock } from '../DebugJsonBlock';

import classes from './Kontact.module.scss';
import WhatsAppButton from '../WhatsAppButton';
import { Gutter } from '../Gutter';
import { useTranslations } from 'next-intl';

export const Kontact: React.FC<{
  className?: string;
  kontact: KontactProps;
}> = ({ className, kontact }) => {
  const { person } = kontact;
  const t = useTranslations('contact');
  const image = person.image as MediaType;
  const mobileImage = person.mobileImage as MediaType;
  return (
    <Gutter>
      <div className={[className, classes.wrapper].filter(Boolean).join(' ')}>
        <div className={classes.imageCol}>
          {image && (
            <Media
              resource={image}
              alt={image.alt}
              imageSize="landscape"
              className={classes.desktopImage}
            />
          )}
          {mobileImage && (
            <Media
              resource={mobileImage}
              alt={mobileImage.alt}
              imageSize="portrait"
              className={classes.mobileImage}
            />
          )}
        </div>
        <div className={classes.contentWrapper}>
          <div className={classes.contentCol}>
            <h2>{`${t('call')} ${person.firstName}`}</h2>
            <div className={classes.name}>{`${person.firstName} ${person.lastName}`}</div>
            <div>{person.jobTitle}</div>
            <a
              className="heading-h3"
              href={`tel:${person.phone.replaceAll(/-|–|\(\d\)|\s/gi, '')}`}
            >
              {person.phone}
            </a>
            <DebugJsonBlock block={person} />
          </div>
          <div className={classes.buttonCol}>
            {person?.mobile && (
              <WhatsAppButton
                phone={person.mobile.replaceAll(/\+|-|–|\(\d\)|\s/gi, '')}
                inverted={true}
              />
            )}
          </div>
        </div>
      </div>
    </Gutter>
  );
};

export default Kontact;
